module.exports = __webpack_public_path__ + "assets/circle-check-icon2.160fca41.svg";